export default __webpack_public_path__ + "static/media/googleBook.a39a4dae.gif";